import { CoursePresenter } from '@/presentation/presenters/problem/coursePresenter'
import { CourseViewModel } from '@/presentation/viewmodels/problem/courseViewModel'

export function useCoursePresenter(presenter: CoursePresenter = new CoursePresenter(new CourseViewModel())) {
  return {
    courseList: presenter.courseList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    getCourseList: presenter.getCourseList.bind(presenter),
    getCourseById: presenter.getCourseById.bind(presenter)
  }
}
